/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { FaInfoCircle } from 'react-icons/fa';

import { genericInputSearchOnPages } from '../../../store/Document/documentActions';
import Loader from '../../Loader';
import Tag from '../../Tag';
import './style.scoped.scss';
import pluralize from 'pluralize';

const ComparisonTags = ({
  allPages,
  handleTagSelected,
  leftID,
  rightID,
}) => {
  const [Top10Tags, setTop10Tags] = useState(null);

  useEffect(() => {
    setTop10Tags(null);
  }, [leftID, rightID, allPages]);

  const handleTags = async () => {
    setTop10Tags(await getTagsList());
  };

  const getTagsList = async () => {
    const AllTags = []; // empty arr

    allPages.forEach((page) => {
      page.tags &&
        page.tags.split(',').forEach((tag) => {
          if (
            !(
              tag.trim().length <= 2 || // has two characters
              tag.match(/[^0-9a-z!\s]/gi) || // has non alphanumeric chars
              (tag.match(/\d/g) && tag.match(/\d/g).length > 1)
            ) // has more than one number
          )
            AllTags.push(tag.trim());
        }); // populate with tags
    });

    const uniqueArray = AllTags.filter(
      (value, index) => AllTags.indexOf(pluralize.singular(value).toLowerCase()) === index
    ) // remove duplicates
      .sort((a, b) => (a > b ? 1 : -1));

    const CountedTags = [];

    // const AllTagsLeft = getAllTagsFromDoc(leftID);
    // const AllTagsRight = getAllTagsFromDoc(rightID);

    for (const uniqueTag of uniqueArray) {
      const leftSearch = await genericInputSearchOnPages(
        uniqueTag,
        allPages.filter((page) => page.documentId === leftID)
      );

      const rightSearch = await genericInputSearchOnPages(
        uniqueTag,
        allPages.filter((page) => page.documentId === rightID)
      );

      const totalSearch = await genericInputSearchOnPages(uniqueTag, allPages);

      CountedTags.push({
        text: uniqueTag,
        leftCount: leftSearch.length,
        rightCount: rightSearch.length,
        totalCount: totalSearch.length,
      });
    }

    return CountedTags.sort((a, b) => b.totalCount - a.totalCount)
      .filter((tag) => tag.leftCount > 0 && tag.rightCount > 0)
      .slice(0, 10);
  };

  const handleSelected = (tag) => {
    handleTagSelected(tag);
  };

  useEffect(() => {
    if (leftID && rightID && !Top10Tags) handleTags();
  }, [leftID, rightID, Top10Tags]);

  return (
    <React.Fragment>
      {allPages && (
        <div className="col comparison-tags-wrapper">
          {/* Document Title */}
          <h3 className="pb-3 heading-override wf-border-b text-center">
            Common Tags
            <FaInfoCircle
              className="ml-2 h5"
              id="help-icon"
              data-toggle="tooltip"
              data-original-title="The 10 most frequent tags on both documents, ordered by total number of page occurences."
            />
          </h3>
          <div className="comparison-tags">
            {Top10Tags ? (
              Top10Tags.map((tag, i) => (
                <Tag text={tag.text} comparisonTag={tag} handleSelected={handleSelected} key={i} />
              ))
            ) : (
              <Loader text="Generating Common Tags..." subText="This might take a few seconds..." />
            )}
          </div>
        </div>
      )}
    </React.Fragment>
  );
};

export default ComparisonTags;
